import { gql } from "@apollo/client";

const EXCHANGE_INSTAGRAM_TOKEN = gql`
  mutation ExchangeInstagramToken($shortLivedToken: String!) {
    exchangeInstagramToken(shortLivedToken: $shortLivedToken) {
      success
      error
      longLivedToken
      expiresIn
    }
  }
`;

export default EXCHANGE_INSTAGRAM_TOKEN;
